import '../scss/style.scss'
import 'outdated-browser-rework/outdated-browser-rework.scss'

import jQuery from 'jquery'

jQuery('body').prepend('<div id="outdated"></div>')

var outdatedBrowserRework = require('outdated-browser-rework')

outdatedBrowserRework({
  browserSupport: {
    'Chrome': 37, // Includes Chrome for mobile devices
    'IE': 11,
    'Safari': 10,
    'Mobile Safari': 9,
    'Firefox': 32
  }
})

require('es6-promise').polyfill()
require('es6-object-assign').polyfill()
require('array.prototype.find').shim()
/* eslint-disable no-extend-native */
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (pattern) {
    var d = this.length - pattern.length
    return d >= 0 && this.lastIndexOf(pattern) === d
  }
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $Session from './Session'
import VueModal from '@citygro/vue-modal'

Vue.use(VueModal)

Vue.use({
  install: function (Vue) {
    const init = Vue.prototype._init
    Vue.prototype._init = function (options) {
      this.$session = $Session

      init.call(this, options)
    }

    // override _destroy
    const destroy = Vue.prototype._destroy
    Vue.prototype._destroy = function () {
      destroy.apply(this, arguments)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js